import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../../css/subPages.css";

import Header from "./Header";
import StartToday from "./StartToday";
import Footer from "../../components/Footer";

export default function CreditTips() {
  return (
    <>
    
      <Header pageSectionId="informationSection" />
      <Container className="subPageContainer">
        <Row className="pt-3 mb-3">
          <Col sm={12} className="text-center">
            <div className="subPageHeadingContainer">
              <h3 className="subPageHeadingText">
                SELF-CARE CREDIT TIPS DURING DIVORCE
              </h3>
            </div>
          </Col>
        </Row>
        <Row className="pt-3 mb-3">
          <Col className="mb-4">
            <ul className="listItems">
              <li className="mb-4">
                <h5 className="subPageListItems">
                  Let creditors know that one spouse isn’t responsible for debts
                  charged to joint accounts by the other spouse after the
                  divorce is finalized
                </h5>
              </li>
              <li className="mb-4">
                <h5 className="subPageListItems">
                  Ask creditors to transfer debt to the name of the person who
                  will be responsible for payment
                </h5>
              </li>
              <li className="mb-4">
                <h5 className="subPageListItems">
                  Always make on-time payments of joint bills – Any late
                  payments will appear on the credit report for the person
                  associated with the account
                </h5>
              </li>
              <li className="mb-4">
                <h5 className="subPageListItems">
                  Keep communication open about which spouse is paying for which
                  bill
                </h5>
              </li>
              <li className="mb-4">
                <h5 className="subPageListItems">
                  Remove a spouse who is an authorized user on an account
                </h5>
              </li>
            </ul>
          </Col>
        </Row>
        <StartToday />
      </Container>
      <Footer />
    
    </>
  );
}
